{
  "title": "Reports",
  "subtitle": "Analytics for {team}.",
  "filters": {
    "all_projects": "All projects",
    "all_departments": "All teams",
    "no_departments": "No teams created",
    "apply_range": "Apply range",
    "from": "From",
    "to": "To",
    "refresh": "Refresh",
    "export_pdf": "Export PDF",
    "exporting": "Generating…",
    "n_teams": "{n} teams",
    "one_team": "1 team",
    "no_teams": "No teams",
    "teams_hint": "Select one or more teams to consolidate the report.",
    "no_departments_hint": "Create teams in your workspace to filter the report by team."
  },
  "periods": {
    "default": "Last 7 days (default)",
    "default_short": "Last 7 days",
    "last_30": "Last 30 days",
    "this_month": "This month",
    "last_month": "Last month",
    "this_quarter": "This quarter",
    "this_year": "This year",
    "custom": "Custom…",
    "range": "{from} – {to}"
  },
  "loading": "Loading reports…",
  "error_load": "Couldn't load reports.",
  "error_pdf": "Couldn't generate the PDF.",
  "ai": {
    "button": "AI summary",
    "generating": "Generating summary…",
    "title": "Executive summary (AI)",
    "error": "Couldn't generate the summary."
  },
  "send": {
    "button": "Send by email",
    "title": "Send report by email",
    "subtitle": "The report PDF will be sent with the current filters.",
    "field_email": "To",
    "field_cc": "CC (optional)",
    "cc_placeholder": "email1@company.com, email2@company.com",
    "field_subject": "Subject (optional)",
    "subject_placeholder": "Team report",
    "field_message": "Message (optional)",
    "message_placeholder": "Write a note for the recipient…",
    "cancel": "Cancel",
    "submit": "Send",
    "sending": "Sending…",
    "success": "Report sent.",
    "error_email_required": "Enter the recipient's email.",
    "error_generic": "Couldn't send the report."
  },
  "kpis": {
    "open": "Open",
    "open_detail": "In progress",
    "completed": "Completed",
    "default_period": "Last 7 days",
    "overdue": "Overdue",
    "overdue_detail": "Past due date",
    "unassigned": "Unassigned",
    "unassigned_detail": "Risk of being forgotten",
    "not_applicable": "Doesn't apply with team filter"
  },
  "workload": {
    "title": "Workload by person",
    "subtitle": "Open tasks",
    "empty": "No one has open tasks assigned."
  },
  "priority": {
    "title": "Pipeline priority",
    "count_open": "{n} open",
    "empty": "No open tasks to prioritize.",
    "urgent": "Urgent",
    "high": "High",
    "medium": "Medium",
    "low": "Low"
  },
  "velocity": {
    "title": "Weekly velocity",
    "created": "Created",
    "completed": "Completed",
    "title_created": "{n} created",
    "title_completed": "{n} completed"
  },
  "by_project": {
    "title": "Status by project",
    "empty": "No projects yet.",
    "done": "Done",
    "pending": "Pending"
  },
  "due": {
    "title": "Due dates",
    "subtitle": "Of open tasks",
    "overdue": "Overdue",
    "today": "Today",
    "this_week": "This week",
    "upcoming": "Upcoming",
    "no_date": "No date"
  },
  "top_collaborators": {
    "title": "Top collaborators",
    "subtitle": "Last 30 days",
    "empty": "No activity this month yet.",
    "task_one": "task completed",
    "task_other": "tasks completed",
    "comment_one": "comment",
    "comment_other": "comments",
    "score": "{n} pts"
  }
}
